export const clearSession = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
};

export const saveSession = (token, user) => {
    localStorage.setItem("token", token);
    localStorage.setItem("user", JSON.stringify(user));
};

export const getStoredUser = () => {
    try {
        const storedUser = localStorage.getItem("user");
        return storedUser ? JSON.parse(storedUser) : null;
    } catch {
        clearSession();
        return null;
    }
};
